'use client';
import { useEffect, useRef, useState } from 'react';

// Phone → magic link on WhatsApp. The server answers the same for known and unknown numbers (no enumeration).
export default function ProLoginForm() {
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [bad, setBad] = useState(false); // the INPUT is wrong (not a 429 / network error)
  const input = useRef<HTMLInputElement>(null); const reset = useRef(false);
  useEffect(() => { if (!done && reset.current) { reset.current = false; input.current?.focus(); } }, [done]); // focus back after "שליחה למספר אחר"
  async function submit(e: React.FormEvent) {
    e.preventDefault(); setErr(null);
    const d = phone.replace(/\D/g, '');
    if (!/^05\d{8}$/.test(d) && !/^9725\d{8}$/.test(d)) { setErr('מספר נייד לא תקין. יש להזין 10 ספרות שמתחילות ב-05.'); setBad(true); return; }
    setBusy(true);
    const r = await fetch('/api/pro/login-link', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone: d }) }).catch(() => null);
    const j = r ? await r.json().catch(() => ({})) : {};
    setBusy(false);
    if (r?.ok && j.ok) setDone(j.message); else { setErr(j.error || 'משהו השתבש. אפשר לנסות שוב.'); setBad(r?.status === 400); }
  }
  if (done) return (
    <div role="status" style={{ display: 'grid', gap: 10, textAlign: 'center' }}>
      <div style={{ fontSize: 40 }} aria-hidden>📲</div>
      <p style={{ margin: 0, fontWeight: 800, color: '#0f172a', lineHeight: 1.6 }}>{done}</p>
      <p style={{ margin: 0, fontSize: 14, color: '#475569', lineHeight: 1.6 }}>הקישור מגיע תוך דקה. לא הגיע? כתבו לנו בוואטסאפ <a href="https://wa.me/972506403800" target="_blank" rel="noopener noreferrer" style={{ color: '#0d47a1', fontWeight: 800, display: 'inline-flex', alignItems: 'center', minHeight: 44 }}><bdi dir="ltr">050-6403800</bdi></a></p>
      <button type="button" onClick={() => { reset.current = true; setDone(null); setPhone(''); }} style={{ minHeight: 44, borderRadius: 12, border: '1px solid #cbd5e1', background: '#fff', color: '#0f172a', fontWeight: 700, cursor: 'pointer' }}>שליחה למספר אחר</button>
    </div>
  );
  return (
    <form onSubmit={submit} noValidate className="space-y-4">
      <div>
        <label htmlFor="pro-phone" className="block text-sm font-semibold mb-1.5" style={{ color: 'var(--color-text-main)' }}>מספר הנייד של העסק</label>
        <input ref={input} id="pro-phone" type="tel" inputMode="numeric" autoComplete="tel" className="input-field" placeholder="050-0000000" dir="ltr"
          value={phone} onChange={e => { setPhone(e.target.value); if (err) { setErr(null); setBad(false); } }} aria-invalid={bad} aria-describedby={err ? 'pro-phone-err' : undefined} style={{ fontSize: 16 }} />
      </div>
      {err && <p id="pro-phone-err" role="alert" style={{ margin: 0, color: '#991b1b', fontSize: 14 }}>{err}</p>}
      <button type="submit" disabled={busy} className="btn-primary w-full justify-center" style={{ minHeight: 48 }}>{busy ? 'שולחים…' : 'שלחו לי קישור כניסה בוואטסאפ'}</button>
    </form>
  );
}
